import React from 'react';
import { ColumnType } from 'antd/lib/table';
import { filter, map } from 'lodash';
import { AccountHelper } from '../../../../helpers/account';
import {
  MedicalAlertClass,
  PriorityLevelEnum,
  SmartAlertTaskStatus,
  Note,
  RoleTypeEnum,
} from '../../../../uc-api-sdk';
import { DisplayDateComponent } from '../../../../uiComponent/DisplayComponent/DisplayDateComponent';
import DisplayOrEmptyComponent from '../../../../uiComponent/DisplayComponent/DisplayOrEmptyComponent';
import { SmartAlertTaskStatusEnumComponent } from '../../../../enumComponent/SmartAlertTaskStatusComponent/SmartAlertTaskStatusComponent';
import { MedicalAlertTaskStatusCellComponent } from './MedicalAlertTaskStatusCellComponent';
import { createEmployeeSearchFilter } from '../../../table/filter/EmployeeSearchFilter';
import {
  PriorityLevelEnumComponent
} from '../../../../enumComponent/PriorityLevelEnumComponent/PriorityLevelEnumComponent';
import { MedicalAlertPriorityLevelComponent } from '../MedicalAlertPriorityLevelComponent/MedicalAlertPriorityLevelComponent';
import { AlertNotesComponent } from '../../../../uiComponent/AlertNotesComponent/AlertNotesComponent';
import { LabelWithValueComponent } from '../../../../uiComponent/LabelWithValueComonent/LabelWithValueComponent';
import './MedicalAlertTaskStatusCellComponent.scss';

export const createColumns = () => ({
  createdAt: (): ColumnType<MedicalAlertClass> => ({
    title: 'Generated time',
    sorter: true,
    render: (value: string) => (
      <DisplayDateComponent value={value} format="DATE_COMMA_TIME_AM_PM" />
    ),
    defaultSortOrder: 'descend',
  }),
  priority: (): ColumnType<MedicalAlertClass> => ({
    title: 'Priority',
    render: (value) => (<MedicalAlertPriorityLevelComponent value={value} />),
    filters: map(filter(PriorityLevelEnum, it => it !== PriorityLevelEnum.level), (value) => ({
      text: (<PriorityLevelEnumComponent value={value} />),
      value,
    })),
  }),
  displayName: (): ColumnType<MedicalAlertClass> => ({
    title: 'Alert',
  }),
  notes: (): ColumnType<MedicalAlertClass> => ({
    title: 'Notes',
    width: '14%',
    render: (notes?: Note[]) => (
      <div className="medical-alert-status-component">
        <LabelWithValueComponent
          showTooltip
          value={<AlertNotesComponent notes={notes} />}
        />
      </div>
    ),
  }),
  status: (): ColumnType<MedicalAlertClass> => ({
    title: 'Status',
    render: (value) => <MedicalAlertTaskStatusCellComponent value={value} />,
    filterMultiple: false,
    filters: map([
      SmartAlertTaskStatus.TODO,
      SmartAlertTaskStatus.DONE,
    ], (value) => ({
      text: (<SmartAlertTaskStatusEnumComponent value={value} />),
      value,
    })),
  }),
  closedBy: (): ColumnType<MedicalAlertClass> => ({
    title: 'Closed by',
    render: (v, alert) => (
      <DisplayOrEmptyComponent
        value={AccountHelper.getFullName(alert.closedByUser)}
      />
    ),
    ...createEmployeeSearchFilter([
      RoleTypeEnum.MA,
      RoleTypeEnum.PROVIDER,
      RoleTypeEnum.RD,
      RoleTypeEnum.HC,
      RoleTypeEnum.CA,
      RoleTypeEnum.NP,
    ]),
  }),
  closedAt: (): ColumnType<MedicalAlertClass> => ({
    title: 'Close time',
    sorter: true,
    render: (value: string) => (
      <DisplayDateComponent value={value} format="DATE_COMMA_TIME_AM_PM" />
    ),
  }),
});
